import { Box, FormControlLabel, Grid, Switch } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AutocompleteComponent from '../../../../components/Autocomplete/Autocomplete';
import CdDrawer from '../../../../components/Drawer/CdDrawer';
import Input from '../../../../components/Input/Input';
import Loading from '../../../../components/Loading';
import TabPanel from '../UsersSave/components/TabPanel';
import useUserShow from './hooks/useUserShow';

function UserDrawerShow({ drawerAction, selectedItem, handleCloseDrawer }: any) {
    const {
        data,
        loading,
        formattedRoles,
        loadingUserData,
        loadingRolePermissions,
        fetchingRolePermissions,
        clearData,
        getFullName,
        ...props
    } = useUserShow({
        selectedItem,
        drawerAction
    });

    return (
        <CdDrawer
            open={drawerAction === 'view'}
            onClose={() => {
                return;
            }}
            onCloseButton={() => {
                clearData();
                handleCloseDrawer();
            }}
            title={selectedItem ? `Usuario ${getFullName(selectedItem?.row)}` : 'Nuevo usuario'}
            icon={<ArrowBackIcon />}
            onSubmit={undefined}
            goBackTxt="Cerrar"
            styles={{ width: '780px' }}
        >
            <Box height="calc(100% - 19px)">
                <Grid container spacing={1} columnSpacing={2} p={1}>
                    {loading || loadingUserData ? (
                        <Grid item xs={12}>
                            <Loading size="medium" />
                        </Grid>
                    ) : (
                        <>
                            <Grid item xs={12} sx={{ '& h3': { mb: 0 } }}>
                                <h3>Datos del usuario</h3>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                sx={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '15px'
                                }}
                            >
                                <Input
                                    label="CUIL"
                                    name="cuilUsuario"
                                    fullWidth
                                    disabled
                                    required
                                    value={data?.cuil || ''}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Input
                                    disabled
                                    label="Nombre"
                                    value={data?.nombre || ''}
                                    className="user-fullname"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Input
                                    disabled
                                    label="Apellido"
                                    value={data?.apellido || ''}
                                    className="user-fullname"
                                    fullWidth
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <AutocompleteComponent
                                    label="Rol"
                                    required
                                    options={formattedRoles}
                                    disabled
                                    value={data?.idRol || ''}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={6}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    '& svg': {
                                        color: 'var(--alternative2)'
                                    }
                                }}
                            >
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={data?.esAdmin || false}
                                            value={data?.esAdmin || false}
                                            disabled
                                            name="esAdmin"
                                            inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                    }
                                    label="Es admin"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TabPanel
                                    data={data}
                                    selectedItem={selectedItem}
                                    clearData={clearData}
                                    loading={loadingRolePermissions || fetchingRolePermissions}
                                    drawerAction={drawerAction}
                                    {...props}
                                />
                            </Grid>
                        </>
                    )}
                </Grid>
            </Box>
        </CdDrawer>
    );
}

export default UserDrawerShow;
